import React from 'react';

export const LeaseDealsDisclaimer = () => (
  <div className="my-3">
    * Lease offers are available to well-qualified lessees with approved credit through participating financial
    institutions. Not all lessees will qualify. Lease terms, including monthly payments, capitalized cost reductions,
    and amounts due at signing, are subject to change and may vary based on creditworthiness, vehicle availability, and
    dealer participation. Offers exclude taxes, title, license, registration, insurance, and dealer fees. Capitalized
    cost reductions may include manufacturer incentives, dealer contributions, and/or loyalty/conquest offers. Lessee is
    responsible for excess wear and tear, mileage overage charges, and a disposition fee at lease end (if applicable).
    While we strive for accuracy, some lease details or vehicle information may be incomplete or unintentionally
    incorrect. Please verify all vehicle specifications and lease terms with the participating dealer. Lease terms and
    offers are subject to change or termination without notice. Offer valid through the date indicated on the lease
    offer. See participating dealer for complete details and vehicle inventory availability. Specific vehicle models and
    trim levels are subject to availability. Residency restrictions may apply. Certain credits may be subject to tax
    implications; consult with a tax professional. Dealer sets actual price. Please consult your selected dealer.
  </div>
);
